import React, { useState, useEffect } from "react";
import "./Complaints.css";

const Complaints = () => {
  useEffect(() => {
      document.title = "Complaints | Qnexa Services — Engineering & Inspection Specialists";
    }, []);
  const [form, setForm] = useState({
    name: "",
    email: "",
    organization: "",
    nature: "",
    incident: "",
    resolution: "",
    consent: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, type: "", message: "" });

  const showToast = (type, message) => {
    setToast({ show: true, type, message });

    setTimeout(() => {
      setToast({ show: false, type: "", message: "" });
    }, 4000);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validate = () => {
    const errs = {};
    if (!form.name.trim()) errs.name = "Name is required";
    if (!form.email.trim()) errs.email = "Email is required";

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (form.email && !emailPattern.test(form.email))
      errs.email = "Enter a valid email";

    if (!form.nature.trim())
      errs.nature = "Please describe nature of complaint";

    if (!form.incident.trim())
      errs.incident = "Please provide incident details";

    if (!form.consent) errs.consent = "Consent is required";

    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length !== 0) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    setLoading(true);

    const data = {
      access_key: "6d478979-816e-4baa-b2fa-c493c9a445bb",
      subject: "New Complaint Submitted",
      from_name: form.name,
      email: form.email,
      message: `
NAME: ${form.name}
EMAIL: ${form.email}
ORGANIZATION: ${form.organization}
NATURE OF COMPLAINT: ${form.nature}
INCIDENT DETAILS: ${form.incident}
DESIRED RESOLUTION: ${form.resolution}
      `,
    };

    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        showToast("success", "Complaint submitted successfully.");

        setForm({
          name: "",
          email: "",
          organization: "",
          nature: "",
          incident: "",
          resolution: "",
          consent: false,
        });
      } else {
        showToast("error", "Failed to submit. Please try again.");
      }
    } catch (err) {
      showToast("error", "Something went wrong.");
    }

    setLoading(false);
  };

  return (
    <>
      {/* ✔ TOAST MESSAGE */}
      {toast.show && (
        <div className={`toast-message ${toast.type}`}>
          {toast.message}
        </div>
      )}

      <div className="complaints-page">
        <div className="complaints-banner">
          <h1>REGISTER COMPLAINT / APPEAL</h1>
        </div>

        <div className="complaints-body">
          <div className="complaints-inner">
            <form className="complaint-form" onSubmit={handleSubmit}>

              <div className="row two-cols">
                <div className="field">
                  <label>Name</label>
                  <input name="name" value={form.name} onChange={handleChange} />
                  {errors.name && <div className="field-error">{errors.name}</div>}
                </div>

                <div className="field">
                  <label>Email</label>
                  <input name="email" value={form.email} onChange={handleChange} />
                  {errors.email && <div className="field-error">{errors.email}</div>}
                </div>
              </div>

              <div className="field full">
                <label>Organization Name</label>
                <input name="organization" value={form.organization} onChange={handleChange} />
              </div>

              <div className="field full">
                <label>Nature of Complaint</label>
                <textarea rows="5" name="nature" value={form.nature} onChange={handleChange} />
                {errors.nature && <div className="field-error">{errors.nature}</div>}
              </div>

              <div className="field full">
                <label>Incident Detail</label>
                <textarea rows="6" name="incident" value={form.incident} onChange={handleChange} />
                {errors.incident && <div className="field-error">{errors.incident}</div>}
              </div>

              <div className="field full">
                <label>Desired Resolution</label>
                <textarea rows="4" name="resolution" value={form.resolution} onChange={handleChange} />
              </div>

              <div className="consent-row">
                <label>
                  <input type="checkbox" name="consent" checked={form.consent} onChange={handleChange} />
                  I agree to the Data Protection Declaration
                </label>
                {errors.consent && <div className="field-error">{errors.consent}</div>}
              </div>

              <button className="submit-btn" disabled={loading}>
                {loading ? "Submitting..." : "Submit Complaint"}
              </button>

            </form>
          </div>
        </div>
      </div>

      {/* ✔ TOAST STYLES */}
      <style>
        {`
        .toast-message {
          position: fixed;
          top: 20px;
          right: 20px;
          padding: 14px 20px;
          border-radius: 8px;
          font-size: 15px;
          font-weight: 500;
          color: white;
          z-index: 9999;
          animation: fadeInOut 4s ease forwards;
        }

        .toast-message.success { background: #28a745; }
        .toast-message.error { background: #dc3545; }

        @keyframes fadeInOut {
          0% { opacity: 0; transform: translateY(-10px); }
          10% { opacity: 1; transform: translateY(0); }
          90% { opacity: 1; transform: translateY(0); }
          100% { opacity: 0; transform: translateY(-10px); }
        }
        `}
      </style>
    </>
  );
};

export default Complaints;
